export const LOG_PAGE_TABS = {
  EDITED: 'edited',
  IGNORED: 'ignored',
  DELETED: 'deleted',
} as const;
